import colors from "./colors";

export const TIMELINE_DAY_CONTAINER_WIDTH = 6;

/**
 * Spacing scale based on an 8px base unit.
 * Token names represent the multiplier percentage of the base unit (e.g., 100 = 1× = 8px).
 * Inspired by Atlassian Design System spacing tokens.
 * @see https://atlassian.design/foundations/spacing/
 */
export const space = {
  "0": 0,
  "025": 2,
  "050": 4,
  "075": 6,
  "100": 8,
  "150": 12,
  "200": 16,
  "250": 20,
  "300": 24,
  "400": 32,
  "500": 40,
  "600": 48
} as const;

/**
 * Border radius scale.
 * Inspired by Atlassian Design System radius tokens.
 * @see https://atlassian.design/foundations/radius/
 */
export const radius = {
  xsmall: 2,
  small: 4,
  medium: 6,
  large: 8,
  xlarge: 12,
  xxlarge: 16,
  full: 9999
} as const;

export const shadows = {
  card: "0 2px 4px 0 rgba(170, 124, 89, 0.15)",
  elevated: "0 1px 8px rgba(51, 43, 37, 0.16)"
} as const;

/**
 * Typography font sizes by variant (in pixels).
 */
export const fontSize = {
  body: 16,
  bodySmall: 14,
  caption: 13,
  captionSmall: 11
} as const;

/**
 * Font weight scale.
 * Prefer the `weight` prop on `<Text>` (e.g. `weight="semibold"`) for emphasized
 * text, and this token for non-Typography elements.
 */
export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  heavy: 800
} as const;

// theme variables not defined in antd
export default {
  "border-base": `1px solid ${colors.lightGrey}`,
  "border-style-base": "solid",
  "border-width-base": "1px",
  "heading-font": "Raleway, Helvetica, sans-serif",
  "monospace-font": "IBM Plex Mono, ui-monospace, monospace",
  "text-color-disabled": colors.lightGrey,
  "text-color-secondary": colors.darkGrey,
  "text-color": colors.textPrimary,
  "text-font": "Inter, Helvetica, sans-serif",
  "timeline-day-container-width-px": `${TIMELINE_DAY_CONTAINER_WIDTH}px`,
  "timeline-day-container-width": TIMELINE_DAY_CONTAINER_WIDTH
};
